export const cols = [{
	prop: 'shopname',
	label: '店铺名称',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercode',
	label: '客户编号',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customersyscoe',
	label: '客户注册码',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'createdate',
	label: '下单时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentdate',
	label: '支付时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundpaymentdate',
	label: '退款时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '订单编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'memo',
	label: '备注',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'paymentserialnumber',
	label: '极速订支付流水号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentnumber',
	label: '第三方订单支付流水号',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundnumber',
	label: '退单编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundpaymentnumber',
	label: '第三方退单支付流水号',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentmode',
	label: '支付方式',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundtype',
	label: '退单类型',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundstatus',
	label: '退单状态',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'money',
	label: '订单交易金额（元）',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundmoney',
	label: '退单交易金额（元）',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'type',
	label: '业务类型',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'lineName',
	label: '所属路线',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderPreMoney',
	label: '预付货款充值金额',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderGiftPreMoney',
	label: '预付货款赠送金额',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundPreMoney',
	label: '预付货款退款充值金额',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundGiftPreMoney',
	label: '预付货款退款赠送金额',
	width: '200',
	ischoose: true,
	align: 'center'
}]
